<div class="half-page card-two scrollable-container">
  <div class="row orderInfo-Header">
    <div class="col-md-12 top-margin2">
      <label class="header-content"><b>Case Number:</b> {{ caseNumber }}</label>
    </div>
  </div>
  <div style="margin: 2% 1% 0% 1%;">
    <mat-card class="mat-card">
      <mat-tab-group class="equal-tabs">
        <mat-tab label="Order Information">
          <div class="tab-content">
            <mat-card class="orderForm-card bg-color">
              <mat-card-header>
                <mat-card-title class="card-title">Order Form</mat-card-title>
              </mat-card-header>

              <mat-card-content class="scrollable-content">
                <div *ngFor="let field of orderFormData">
                  <div class="row col-md-12 reduce-lines-space">
                    <hr>
                    <div class="col-md-5" style="text-align: left;">
                      <label class="text-form-label">{{ field.displayLabel }}</label>
                    </div>
                    <div class="col-md-1" style="text-align: left;">:</div>
                    <div class="col-md-6" style="text-align: left;">
                      <label class="text-form-value">{{ field.value }}</label>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="requestorInfo-card bg-color">
              <mat-card-header>
                <mat-card-title class="card-title">Order Details</mat-card-title>
              </mat-card-header>

              <mat-card-content class="scrollable-content">
                <div *ngFor="let field of orderInfo">
                  <div class="row col-md-12 reduce-lines-space">
                    <hr>
                    <div class="col-md-5" style="text-align: left;">
                      <label class="text-form-label">{{ splitCamelCase(field.key) }}</label>
                    </div>
                    <div class="col-md-1" style="text-align: left;">:</div>
                    <div class="col-md-6" style="text-align: left;">
                      <label class="text-form-value">{{ field.value }}</label>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="requestorInfo-card bg-color">
              <mat-card-header>
                <mat-card-title class="card-title">Requestor Information</mat-card-title>
              </mat-card-header>

              <mat-card-content class="scrollable-content">
                <div *ngFor="let field of requestorDetails">
                  <div class="row col-md-12 reduce-lines-space">
                    <hr>
                    <div class="col-md-5" style="text-align: left;">
                      <label class="text-form-label formatted-text">{{ splitCamelCase(field.key) }}</label>
                    </div>
                    <div class="col-md-1" style="text-align: left;">:</div>
                    <div class="col-md-6" style="text-align: left;">
                      <label class="text-form-value">{{ field.value }}</label>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="courtInfo-card bg-color">
              <mat-card-header>
                <mat-card-title class="card-title">Court Information</mat-card-title>
              </mat-card-header>

              <mat-card-content class="scrollable-content">
                <div *ngFor="let field of courtInfo">
                  <div class="row col-md-12 reduce-lines-space">
                    <hr>
                    <div class="col-md-5" style="text-align: left;">
                      <label class="text-form-label">{{ splitCamelCase(field.key) }}</label>
                    </div>
                    <div class="col-md-1" style="text-align: left;">:</div>
                    <div class="col-md-6" style="text-align: left;">
                      <label class="text-form-value">{{ field.value }}</label>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab label="Order Notes">
          <div class="tab-content">
            <mat-card class="notes-card bg-color">
              <mat-card-header class="notes-card-header">
                <button style="background-color: #F1F8E9; border: none" (click)="refreshNotes()">
                  <img src="../../../assets/img/icon/refresh.png" alt="Refresh" style="height:24px; width:24px;">
                </button>
              </mat-card-header>
              <mat-card-content class="scrollable-content">
                <div *ngFor="let note of orderNotes; let i = index" class="note-message" style="margin-bottom: 10px;">

                  <div style="display: flex; align-items: center; width: 100%;">
                    <span style="display: flex; gap: 10px; align-items: center;">
                      <strong>{{ note.UserName }}</strong>
                      <span class="note-time">{{ note.CreatedAt | date:'dd/MMM/yyyy HH:mm' }}</span>
                    </span>
                    <span *ngIf="note.UserName === currentUserName" style="margin-left: auto; display: flex; gap: 5px;">
                      <button *ngIf="!note.isEditing" class="edit-icon-button" title="Edit" (click)="editNote(i)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button *ngIf="!note.isEditing" class="edit-icon-button" title="Delete" (click)="deleteNote(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                      <button *ngIf="note.isEditing" class="edit-icon-button" title="Update" (click)="updateNote(i)">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button *ngIf="note.isEditing" class="edit-icon-button" title="Cancel" (click)="cancelEdit(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                  </div>
                  <div style="margin-top: 4px; padding-left: 5px;">
                    <div *ngIf="!note.isEditing">{{ note.Message }}</div>
                    <textarea *ngIf="note.isEditing" [(ngModel)]="note.editMessage" rows="2" style="width: 100%;height: 80px;"></textarea>
                  </div>
                </div>
              </mat-card-content>
              <div class="note-input">
                <mat-form-field class="note-textbox" appearance="outline">
                  <input matInput placeholder="Type a note..." [(ngModel)]="newNote" (keyup.enter)="sendNote()" maxlength="1000">
                </mat-form-field>
                <button mat-raised-button data-tippy-content="Send" data-tippy-trigger="mouseenter focus"
                  data-tippy-arrow="true" data-tippy-placement="bottom" data-tippy-offset="[0, 5]" (click)="sendNote()"
                  style="height: 1%;margin-top: 1%;">
                  <mat-icon>send</mat-icon>
                </button>
              </div>
            </mat-card>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </div>
</div>